import { render, staticRenderFns } from "./SlotMachine.vue?vue&type=template&id=2d35c5aa&scoped=true"
import script from "./SlotMachine.vue?vue&type=script&lang=js"
export * from "./SlotMachine.vue?vue&type=script&lang=js"
import style0 from "./SlotMachine.vue?vue&type=style&index=0&id=2d35c5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d35c5aa",
  null
  
)

export default component.exports